<template>
  <div class="xy-activity-marquee">
    <marquee class="xy-activity-marquee__content" :content="props.content" :delay="props.delay" :speed="props.speed"
      :autoResume="props.autoResume" :direction="props.direction || 'horizontal'" :wrapWidth="props.wrapWidth"
      :wrapHeight="props.wrapHeight" :scrollDirection="props.scrollDirection">
      <template v-if="props.content.length > 0">
        <div class="xy-activity-marquee__content--box"
          :style="{ direction: props.scrollDirection === 'rtl' ? 'ltr' : 'rtl', margin: props.direction === 'horizontal' ? '0px 80px' : '10px 0px' }"
          v-for="(item, index) in props.content" :key="index">
          <img v-if="item.img" :src="item.img" alt="">
          <div v-html="item.message"></div>
        </div>
      </template>
    </marquee>
  </div>
</template>

<script setup>
import { info, defaultProps } from './config'
import Marquee from '../components/marquee.vue'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
</script>

<style lang="scss" scoped>
.xy-activity-marquee {
  width: 100%;
  height: 100%;

  .xy-activity-marquee__content {
    width: 100%;
    height: 100%;

    .xy-activity-marquee__content--box {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // margin-left: 80px;
      // margin-right: 80px;

      img {
        width: auto;
        height: 100%;
        border-radius: 50%;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
}
</style>
